import { VendorPriceFormat } from "../helpers/priceFormatter";

export interface Vendor {
  id: number;
  channel: string;
  oldName?: string;
  locale: string;
  country: string;
  prices: VendorPriceFormat;
}

//todo Ids must match https://github.com/albumprinter/storefront-public-configuration/blob/master/source_configs/vendors.json move here and lookup
export const vendors: Vendor[] = [
  {
    id: 1,
    channel: "albelli.nl",
    locale: "nl-NL",
    country: "NL",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
    },
  },
  {
    id: 2,
    channel: "albelli.be",
    locale: "nl-BE",
    country: "BE",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
    },
  },
  {
    id: 3,
    channel: "albelli.de",
    locale: "de-DE",
    country: "DE",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      appendAsterisk: true,
      currencySymbolAppended: true,
    },
  },
  {
    id: 4,
    channel: "monalbumphoto.fr",
    locale: "fr-FR",
    country: "FR",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true,
    },
  },
  {
    id: 5,
    channel: "onskefoto.se",
    oldName: "albelli.se",
    locale: "sv-SE",
    country: "SE",
    prices: {
      currencySymbol: "kr",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true,
      dropZeroDecimals: true,
    },
  },
  {
    id: 6,
    channel: "fotoknudsen.no",
    locale: "nb-NO",
    country: "NO",
    prices: {
      currencySymbol: "kr",
      decimalSeparator: ",",
      thousandsSeparator: " ",
      zeroDecimalsReplacement: "-",
    },
  },
  {
    id: 7,
    channel: "bonusprint.co.uk",
    locale: "en-GB",
    country: "UK",
    prices: {
      currencySymbol: "£",
      decimalSeparator: ".",
      thousandsSeparator: ",",
    },
  },
  {
    id: 8,
    channel: "posterxxl.de",
    locale: "de-DE",
    country: "PXXLDE",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      appendAsterisk: true,
      currencySymbolAppended: true,
    },
  },
  {
    id: 9,
    channel: "posterxxl.at",
    locale: "de-AT",
    country: "AT",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      appendAsterisk: true,
      currencySymbolAppended: true,
    },
  },
  {
    id: 10,
    channel: "b2b.posterxxl.de",
    locale: "de-DE",
    country: "PXXLDE",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      appendAsterisk: true,
      currencySymbolAppended: true,
    },
  },
  {
    id: 11,
    channel: "photobox.co.uk",
    locale: "en-GB",
    country: "UK",
    prices: {
      currencySymbol: "£",
      decimalSeparator: ".",
      thousandsSeparator: ",",
      currencySymbolNoSpacing: true,
    },
  },
  {
    id: 12,
    channel: "photobox.fr",
    locale: "fr-FR",
    country: "FR",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true,
    },
  },
  {
    id: 13,
    channel: "photobox.ie",
    locale: "en-IE",
    country: "IE",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ".",
      thousandsSeparator: ",",
      currencySymbolNoSpacing: true,
    },
  },
  {
    id: 14,
    channel: "photobox.it",
    locale: "it-IT",
    country: "IT",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true,
    },
  },
  {
    id: 15,
    channel: "photobox.dk",
    locale: "da-DK",
    country: "DK",
    prices: {
      currencySymbol: "kr.",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true,
    },
  },
  {
    id: 16,
    channel: "hofmann.es",
    locale: "es-ES",
    country: "ES",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true,
    },
  },
  {
    id: 17,
    channel: "hofmann.pt",
    locale: "pt-PT",
    country: "PT",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true,
    },
  },
];
